import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { Dispatch } from 'redux'
import { getGroups } from '../../actions/groups'
import { IGroup } from '../../types/group'
import { DefaultHomePage } from './DefaultHomePage'

export interface IHomePage {
  groupsLoading: boolean
  groupsLoaded: boolean
  groupsList: IGroup[]
  dispatch: Dispatch
}

export const HomePage = ({
  groupsLoading,
  groupsLoaded,
  groupsList,
  dispatch,
}: IHomePage) => {
  useEffect(() => {
    if (!groupsLoaded && !groupsLoading) {
      dispatch(getGroups())
    }
  }, [dispatch, groupsLoaded, groupsLoading])

  if (groupsLoading) {
    return null
  }
  return groupsList.length > 0 ? (
    <Redirect to={`/group/${groupsList[0].name}`} />
  ) : (
    <DefaultHomePage />
  )
}
